<template>
  <v-container>
    <div style="text-align: center" class="mt-4 mb-4">
      <span style="color: #005ca3" class="display-1 font-weight-thin">
        Bem vindo ao sistema online para pagamentos ao
        <br />Fornecedor e Colaborador
      </span>
      <br />
      <span class="font-weight-thin blue-grey--text lighten-2">
        <span class="font-weight-bold">R</span>eembolso |
        <span class="font-weight-bold">A</span>diantamento |
        <span class="font-weight-bold">P</span>restação de contas
      </span>
    </div>

    <v-card class="pa-4 ma-auto elevation-3 grey lighten-4" max-width="600">
      <v-card-title>
        <div>
          <img
            src="https://storage.googleapis.com/catho-repositorio/logo/logo.png"
            style="width: 20%"
          />
        </div>
        <span style="color: #ff0d7b" class="headline font-weight-bold"
          >Entrar</span
        >
        <v-spacer></v-spacer>
      </v-card-title>

      <v-card-text class="mt-3">
        <v-layout row wrap class="text-xs-center">
          <v-flex xs12>
            <v-btn
              id="login-google"
              :class="`botao-login-google ${
                validarTamanhoTelaUsuario($vuetify.breakpoint) == 'medium'
                  ? 'botao-tela-media-maior'
                  : 'botao-tela-pequena-menor'
              }`"
              flat
              :disabled="loadingLogin"
            >
              Fazer login Com Google
            </v-btn>
          </v-flex>
          <v-flex xs12>
            <p style="color: #ff0d7b" v-if="erroLogin && !loadingLogin">
              E-mail não cadastrado. Entre em contato com o administrador de
              T.I.
            </p>
            <p style="color: #005ca3" v-if="loadingLogin">
              Aguarde um momento, estamos autenticando seu usuário.
            </p>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      valid: false,
      erroLogin: false,
      loadingLogin: false,
      usuario: {
        email: "",
      },
      loginRules: [
        (v) => !!v || "Por favor, preencha o campo e-mail.",
        (v) =>
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          "Por favor, digite um e-mail válido.",
      ],
    };
  },
  mounted() {
    const tamanhoTelaUsuario = this.$vuetify.breakpoint;
    window.onGoogleLibraryLoad = () => {
      this.configurarBotaoGoogle(
        this.validarTamanhoTelaUsuario(tamanhoTelaUsuario)
      );
    };
    this.configurarBotaoGoogle(
      this.validarTamanhoTelaUsuario(tamanhoTelaUsuario)
    );
  },
  methods: {
    configurarBotaoGoogle(tamanho) {
      window.google.accounts.id.initialize({
        client_id:
          "895420842124-mfi4vmbnn6fi4r54n3usml7pe9l2qbru.apps.googleusercontent.com",
        callback: this.loginGoogle,
      });
      window.google.accounts.id.renderButton(
        document.getElementById("login-google"),
        {
          theme: "filled_blue",
          size: "medium",
          type: "standard",
          text: "sign_in_with",
          width: tamanho == "medium" ? 400 : 200,
        }
      );
    },
    async loginGoogle(respostaGoogle) {
      const idToken = respostaGoogle.credential;
      this.loadingLogin = true;

      try {
        const response = await axios({
          method: "post",
          url: "/login/google",
          responseType: "json",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          },
          data: idToken,
        });

        this.erroLogin = false;

        let autenticacao = response.data;
        autenticacao.token = idToken;
        localStorage.setItem("usuarioLogado", JSON.stringify(autenticacao));
        if (
          response.data.papeis.filter((papel) => {
            return papel.nome === "ADMIN";
          }).length > 0
        ) {
          this.$router.push({ name: "usuarios" });
        } else {
          this.$router.push({ name: "Home" });
        }
        this.$store.commit("set", {
          itemName: "loggedUser",
          content: autenticacao,
        });
        this.$store.commit("set", {
          itemName: "isAuth",
          content: true,
        });
      } catch (error) {
        this.erroLogin = true;
        this.$store.commit("set", {
          itemName: "isAuth",
          content: false,
        });
        this.loadingLogin = false;
      }
    },
    validarTamanhoTelaUsuario(telaUsuario) {
      const telaEhMediaOuMaior =
        telaUsuario.md || telaUsuario.lg || telaUsuario.xl;
      return telaEhMediaOuMaior ? "medium" : "small";
    },
  },
  watch: {
    "$vuetify.breakpoint": {
      handler(novaTelaUsuario, antigaTelaUsuario) {
        const novaTela = this.validarTamanhoTelaUsuario(novaTelaUsuario);
        const antigaTela = this.validarTamanhoTelaUsuario(antigaTelaUsuario);
        if (novaTela != antigaTela) this.configurarBotaoGoogle(novaTela);
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.botao-login-google {
  text-transform: initial;
}
.botao-tela-pequena-menor {
  width: 200px;
  height: 22px;
}
.botao-tela-media-maior {
  width: 400px;
}
</style>